export enum ErrorState {
	NULL = 'NULL',
	MESSAGE = 'MESSAGE',
	NO_ERROR = 'NO_ERROR',
}
